import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/kontakt/bg_kontakt.png";
import Gruppe1 from "../../images/kontakt/HerzdoktorGruppe2025-010.jpeg";
import Gruppe2 from "../../images/kontakt/HerzdoktorGruppe2025-002.jpeg";
import Video from '../../images/kontakt/bewerbungs_video.mp4'

const CardiologyJobPosting = () => {
    return (
        <div>
          <h2>
            Fachärztin/Facharzt für Innere Medizin mit Zusatzfach Kardiologie gesucht (20–38 h/Woche)
          </h2>
          <p>Willkommen im grünen Herzen von 1150 Wien!</p>
    
          <p>
            Wir sind eine etablierte kardiologische Kassenordination im 15. Bezirk mit einem engagierten,
            familiären Team und suchen <b> Verstärkung durch eine/n Fachärztin/Facharzt für Innere Medizin mit
            Zusatzfach Kardiologie.</b>
          </p>
    
          <section>
            <h3>Was Sie bei uns erwartet:</h3>
            <ul>
              <li>Eine <b>moderne Ordination im begrünten Innenhof</b>– ein Ort zum Wohlfühlen für Patient*innen und Team</li>
              <li>Ein <b>wertschätzendes, freundliches, familiäres und kollegiales Arbeitsklima </b>mit gegenseitiger Unterstützung</li>
              <li>Flexible <b>Anstellung im Ausmaß von 20 bis 38 Wochenstunden</b>, an 4 oder 5 Tagen pro Woche möglich</li>
              <li>Eigenverantwortliches Arbeiten in einem spannenden Fachgebiet</li>
            </ul>
          </section>
    
          <section>
            <h3>Ihre fachlichen Kompetenzen:</h3>
            <ul>
              <li>Abgeschlossene Ausbildung zur/zum Fachärztin/Facharzt für Innere Medizin mit Zusatzfach Kardiologie</li>
              <li>Erfahrung und sichere Anwendung in folgenden Bereichen:</li>
              <ul>
                <li><b>Herzultraschall (Echokardiographie)</b></li>
                <li><b>Carotis-Sonographie</b></li>
                <li><b>Schilddrüsen-Sonographie</b></li>
              </ul>
            </ul>
          </section>
    
          <section>
            <h3>Wir freuen uns auf Sie, wenn Sie:</h3>
            <ul>
              <li>Freude an der Arbeit mit Patient*innen mitbringen</li>
              <li>Teamgeist, Empathie und Verlässlichkeit ausstrahlen</li>
              <li>Eine moderne, strukturierte Arbeitsweise schätzen</li>
            </ul>
          </section>
    
          <section>
            <h3>📧 Kontakt:</h3>
            <p>Bei Interesse freuen wir uns über eine Kontaktaufnahme über unser Kontaktformular. </p>
            <p>
              Mehr über uns:{" "}
              <a href="https://www.herzdoktor.net" target="_blank" rel="noopener noreferrer">
                www.herzdoktor.net
              </a>
            </p>
          </section>
        </div>
    )
  }

  const ResponsiveLayout = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap", // allows wrapping on smaller screens
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "20px", // space between items
        }}
      >
        {/* Image column */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px",
            flex: "1 1 300px", // grow/shrink for responsiveness
          }}
        >
          <img
            src={Gruppe1}
            alt=""
            style={{ maxWidth: "100%", height: "auto" }}
          />
          <img
            src={Gruppe2}
            alt=""
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
  
        {/* Video */}
        <div
          style={{
            flex: "1 1 360px", // responsive width
            display: "flex",
            justifyContent: "center",
          }}
        >
          <video
            width="100%" // makes video adapt to container
            height="auto"
            controls
            autoPlay={false}
            loop={false}
            style={{ borderRadius: "10px", maxWidth: "400px" }}
          >
            <source src={Video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    );
  };
  

const Jobs = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Jobs / Bewerbungen </h1>
                    
                    <p className="page-text">
                        Wir freuen uns über Initiativbewerbungen{/* Derzeit keine Stellen vakant frei, aber Initiativbewerbungen immer willkommen! */ }
                        <br /> <br />
                        Wir bitten um Ihre Bewerbung mit Lebenslauf an:
                    </p>
                    <h3> Ordination Wien </h3>
                    
                    <table>
                        <tr>
                            <th></th>
                            <th>Dr. Claudia Sebald</th>
                        </tr>
                        <tr>
                            <td>PLZ / Ort:</td>
                            <td>1150 Wien</td>
                        </tr>
                        <tr>
                            <td>Straße:</td>
                            <td>Kranzgasse 22 / Hoftrakt</td>
                        </tr>
                        <tr>
                            <td>Tel.:</td>
                            <td>+43 1 892 17 17</td>
                        </tr>
                        <tr>
                            <td>Fax:</td>
                            <td>+43 1 892 17 17 - 4</td>
                        </tr>
                    </table>
                </div>

                

            </section>
            <Footer />
        </main>
    )
}

export default Jobs;
